export default __webpack_public_path__ + "static/media/i065vp.13dec521.webp";